import {
    OptionPicker,
    createOptionPicker,
} from '@vfde-brix/ws10/option-picker';
import { startAppListening } from '../../../app/listener';
import { useAppDispatch } from '../../../app/store';
import { disableOptionPicker } from '../../../components/OptionPicker';
import { selectCustomerConfig } from '../../app/slice';
import {
    TRADEIN_OPTION_PICKER_VALUE_YES,
    TRADEIN_OPTION_PICKER_VALUE_NO,
} from '../constants';
import {
    setIsTradeInSelected,
    setInitialState,
    selectIsTradeInSelected,
} from '../slice';

/**
 * Mount the tradein option picker
 */
export const mountTradeInOptionPicker = (containerId: string): OptionPicker | null => {
    const container = document.getElementById(containerId);

    /* istanbul ignore if */
    if (!container) {
        return null;
    }

    const dispatch = useAppDispatch();

    const onChange = (event: Event) => {
        const value = (event.target as HTMLInputElement).value;
        const isTradeInSelected = value === TRADEIN_OPTION_PICKER_VALUE_YES;

        dispatch(setIsTradeInSelected(isTradeInSelected));
    };

    const optionPicker = createOptionPicker(container, { onChange });

    listenForUpdates(optionPicker);

    return optionPicker;
};

const listenForUpdates = (optionPicker: OptionPicker) => {
    startAppListening({
        actionCreator: setInitialState,
        effect: (_action, listenerApi) => {
            const state = listenerApi.getState();
            const customerConfig = selectCustomerConfig(state);
            const { isTradeIn, isHardwareOnly } = customerConfig;
            const isTradeInSelected = selectIsTradeInSelected(state);

            // Browsers try to remember the last 'checked' state of checkboxes/radio buttons after a page reload
            // so we have to manually set it to the correct state based on the customerConfig
            optionPicker.setValue(isTradeIn ? TRADEIN_OPTION_PICKER_VALUE_YES : TRADEIN_OPTION_PICKER_VALUE_NO);
            optionPicker.toggleContainer(false, true);

            enableOrDisableOptions(optionPicker, !isHardwareOnly, isTradeInSelected);
        },
    });

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectCustomerConfig(currentState).isHardwareOnly !== selectCustomerConfig(previousState).isHardwareOnly
        ,
        effect: (_action, listenerApi) => {
            const state = listenerApi.getState();
            const customerConfig = selectCustomerConfig(state);
            const { isHardwareOnly } = customerConfig;
            const isTradeInSelected = selectIsTradeInSelected(state);

            enableOrDisableOptions(optionPicker, !isHardwareOnly, isTradeInSelected);
        },
    });
};

const enableOrDisableOptions = (optionPicker: OptionPicker, shouldEnable: boolean, isTradeInSelected: boolean) => {
    if (shouldEnable) {
        enableTradeInOptionPicker(optionPicker, isTradeInSelected);
    }
    else {
        disableOptionPicker(optionPicker);
    }
};

/**
 * Enables all optionPicker options and sets the optChecked of the default item to true
 */
const enableTradeInOptionPicker = (optionPicker: OptionPicker, isTradeInSelected: boolean) => {
    optionPicker.enableAllOptions(isTradeInSelected ? TRADEIN_OPTION_PICKER_VALUE_YES : TRADEIN_OPTION_PICKER_VALUE_NO);
};
